import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';
import {ErrorsFromBE, ErrorResponse, SuccessResponse, takeLatestF} from 'favorlogic-utils';

import {handleResponseError} from 'utils/handleResponseError';

import {loadMeasurementsSuccess, loadMeasurementsError, LoadMeasurementsAction} from '../actions';
import {MeasurementDetailsPage} from 'types/model/measurements/MeasurementDetailsPage';
import Api from '../api';

function* handleErrorResponse(response: ErrorResponse): SagaIterator {
    const title = 'Načtení měření';
    const error = response.data as ErrorsFromBE;

    yield* call(handleResponseError, response, title);
    yield* put(loadMeasurementsError(error));
}

function* handleSuccessResponse(response: SuccessResponse<MeasurementDetailsPage>): SagaIterator {
    yield* put(loadMeasurementsSuccess(response.data));
}

function* execute(action: LoadMeasurementsAction): SagaIterator {
    const response = yield* call(Api.getMeasurements, action.payload);

    yield* response.isSuccess ? call(handleSuccessResponse, response) : call(handleErrorResponse, response);
}

export function* loadMeasurementsSaga(): SagaIterator {
    yield takeLatestF('measurement/LOAD_MEASUREMENTS', execute);
}
